import $i18n from 'panda-i18n';
/**
 * @description 是否按库区拆分
 */
const IS_SPLIT = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: true,
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: false,
  },
];

/**
 * @description 拆货换箱时间类型
 */

const DEVAN_TIME_TYPE = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },
  {
    label: $i18n.get({ id: 'StartTime.four_px', dm: '开始时间' }),
    value: 'startTime',
  },
  {
    label: $i18n.get({ id: 'EndTime.four_px', dm: '结束时间' }),
    value: 'endTime',
  },
];

/**
 * @description 拆货换箱差异类型
 */
const DIFF_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
  {
    label: $i18n.get({ id: 'Difference.four_px', dm: '有差异' }),
    value: 'Y',
  },
  {
    label: $i18n.get({ id: 'NoDifference.four_px', dm: '无差异' }),
    value: 'N',
  },
];

/**
 * @description 拆货换箱单据类型
 */

const DEVAN_LIST_TYPE = [
  {
    label: $i18n.get({ id: 'UnpackingLabelChangedWorkOrder.four_px', dm: '拆箱换标作业单' }),
    value: 'jobNo',
  },
  {
    label: $i18n.get({ id: 'JHZYDH.PickingOrderNumber.four_px', dm: '拣货作业单号' }),
    value: 'pickNo',
  },
];

/**
 * @description 补货状态
 */
const REPLENISH_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'ToBeReplenished.four_px', dm: '待补货' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'ReplenishmentInProgress.four_px', dm: '补货下架中' }),
    value: '11',
  },

  {
    label: $i18n.get({ id: 'ReplenishedAndRemoved.four_px', dm: '已补货下架' }),
    value: '12',
  },

  {
    label: $i18n.get({ id: 'ReplenishmentOnShelves.four_px', dm: '补货上架中' }),
    value: '20',
  },

  {
    label: $i18n.get({ id: 'ReplenishedAndPutOnShelves.four_px', dm: '已补货上架' }),
    value: '30',
  },

  {
    label: $i18n.get({ id: 'YSC.Deleted.four_px', dm: '已删除' }),
    value: '50',
  },
];

/**
 * @description 补货类型
 */
const REPLENISH_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'DailyReplenishment.four_px', dm: '日常补货' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'AbcDatabaseMigration.four_px', dm: 'ABC移库' }),
    value: '20',
  },

  {
    label: $i18n.get({ id: 'TransferToStorage.four_px', dm: '转存移库' }),
    value: '30',
  },

  {
    label: $i18n.get({ id: 'InventoryEmergencyReplenishment', dm: '库存紧急补货' }),
    value: '40',
  },
  {
    label: $i18n.get({ id: 'RemittanceEmergencyReplenishment', dm: '汇单紧急补货' }),
    value: '45',
  },
  {
    label: $i18n.get({ id: 'EmergencyOrder', dm: '接单紧急' }),
    value: '50',
  },
];

/**
 * @description 补货货型
 */
const REPLE_CARGO_TYPE = [
  {
    label: 'T25',
    value: 'S',
  },

  {
    label: 'T50',
    value: 'M',
  },

  {
    label: 'T120',
    value: 'L',
  },

  {
    label: 'T240',
    value: 'O',
  },

  {
    label: 'TM',
    value: 'W',
  },
];

/**
 * @description 补货时间类型
 */
const REPLENISH_TIME_TYPE = [
  {
    label: $i18n.get({ id: 'EarliestEstimatedOutboundTime.four_px', dm: '最早预计出库时间' }),
    value: 'O',
  },
];

/**
 * @description 确认差异
 */
const ENTER_DIFFER = [
  {
    label: $i18n.get({ id: 'NotConfirmed.four_px', dm: '未确认' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'Confirmed.four_px', dm: '已确认' }),
    value: '30',
  },
];

/**
 * @description 异常类型
 */
const ABNOR_TYPE = [
  {
    label: $i18n.get({ id: 'UnshelvingException.four_px', dm: '下架异常' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'ShelvingException.four_px', dm: '上架异常' }),
    value: 'P',
  },
];

/**
 * @description 动作
 */
const ACTION_TYPE = [
  {
    label: $i18n.get({ id: 'Shelves.four_px', dm: '下架' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'WP',
  },
];

const REPLE_ABCTYPE = [
  {
    label: 'A',
    value: 'A',
  },
  {
    label: 'B',
    value: 'B',
  },
  {
    label: 'C',
    value: 'C',
  },
  {
    label: 'D',
    value: 'D',
  },
  {
    label: 'E',
    value: 'E',
  },
];

const INVENTORY_LIST_TAB = [
  {
    label: $i18n.get({ id: 'PreliminaryCheck.four_px', dm: '初盘' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'Replaying.four_px', dm: '复盘' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: '30',
  },
];

const INVENTORY_FIND_TAB = [
  {
    label: $i18n.get({ id: 'PreliminaryCheck.four_px', dm: '初盘' }),
    value: '12',
  },
  {
    label: $i18n.get({ id: 'Replaying.four_px', dm: '复盘' }),
    value: '30',
  },
];

const INVENTORY_ANBOR_TAB = [
  {
    label: $i18n.get({ id: 'PreliminaryCheck.four_px', dm: '初盘' }),
    value: '12',
  },
  {
    label: $i18n.get({ id: 'Replaying.four_px', dm: '复盘' }),
    value: '30',
  },
];

const CHECK_MODE = [
  {
    label: $i18n.get({ id: 'BrightPlate.four_px', dm: '明盘' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'BlindDisk.four_px', dm: '盲盘' }),
    value: '20',
  },
];

const IS_SPLICE = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: 'Y',
  },
  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
];

const RANGE_SOURCE = [
  {
    label: $i18n.get({ id: 'FileImport.four_px', dm: '文件导入' }),
    value: 'IM',
  },
  {
    label: $i18n.get({ id: 'SpecifiedRegion.four_px', dm: '指定区域' }),
    value: 'SA',
  },
];

const CHECK_TYPE = [
  {
    label: $i18n.get({ id: 'ExceptionCheck.four_px', dm: '异常盘点' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'GeneralInventory.four_px', dm: '普通盘点' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'TouchInventory.four_px', dm: '动碰盘点' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: 'TailInventory', dm: '尾货盘点' }),
    value: '40',
  },
  {
    label: $i18n.get({ id: 'ProductAlignment', dm: '对品对位' }),
    value: '50',
  },
];

const CHECK_TYPE_CREATE = [
  {
    label: $i18n.get({ id: 'GeneralInventory.four_px', dm: '普通盘点' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'TouchInventory.four_px', dm: '动碰盘点' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: 'TailInventory', dm: '尾货盘点' }),
    value: '40',
  },
  {
    label: $i18n.get({ id: 'ProductAlignment', dm: '对品对位' }),
    value: '50',
  },
];

const CHECK_MODE_ALL = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
  {
    label: $i18n.get({ id: 'BrightPlate.four_px', dm: '明盘' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'BlindDisk.four_px', dm: '盲盘' }),
    value: '20',
  },
];

const CHECK_TYPE_ALL = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
  {
    label: $i18n.get({ id: 'ExceptionCheck.four_px', dm: '异常盘点' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'GeneralInventory.four_px', dm: '普通盘点' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'TouchInventory.four_px', dm: '动碰盘点' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: 'TailInventory', dm: '尾货盘点' }),
    value: '40',
  },
  {
    label: $i18n.get({ id: 'ProductAlignment', dm: '对品对位' }),
    value: '50',
  },
];

const CHECK_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
  {
    label: $i18n.get({ id: 'NotChecked.four_px', dm: '未盘点' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'InitialDiskInProgress.four_px', dm: '初盘中' }),
    value: '11',
  },
  {
    label: $i18n.get({ id: 'InitialDisk.four_px', dm: '已初盘' }),
    value: '12',
  },
  {
    label: $i18n.get({ id: 'Retrending.four_px', dm: '复盘中' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'Restored.four_px', dm: '已复盘' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: '40',
  },
  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: '50',
  },
];

const CHECK_TASK_TYPE = [
  {
    label: $i18n.get({ id: 'Count.four_px', dm: '盘点' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: '20',
  },
];

const IS_DIFF = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
  {
    label: $i18n.get({ id: 'NotAdjusted.four_px', dm: '未调整' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'Adjusting.four_px', dm: '调整中' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'InsufficientAvailableInventory.four_px', dm: '可用库存不足' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: 'Adjusted.four_px', dm: '已调整' }),
    value: '40',
  },
];

const IS_DIFF_TABLE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
  {
    label: $i18n.get({ id: 'NotAdjusted.four_px', dm: '未调整' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'Adjusting.four_px', dm: '调整中' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'InsufficientAvailableInventory.four_px', dm: '可用库存不足' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: 'Adjusted.four_px', dm: '已调整' }),
    value: '40',
  },
];

const INVENTORY_STATUS = [
  {
    label: $i18n.get({ id: 'NotAdjusted.four_px', dm: '未调整' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'AdjustedButNotReturned.four_px', dm: '已调整未返回' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'InsufficientAvailableInventory.four_px', dm: '可用库存不足' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: 'Adjusted.four_px', dm: '已调整' }),
    value: '40',
  },
];

const MOVEKU_ACTION_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '999',
  },

  {
    label: $i18n.get({ id: 'Shelves.four_px', dm: '下架' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'W',
  },
  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'WP',
  },
];

const INVENTORY_STRATEGY_MODEL = [
  {
    label: $i18n.get({ id: 'CheckIn.four_px', dm: '入库' }),
    value: 'I',
  },
  {
    label: $i18n.get({ id: 'CheckedOut.four_px', dm: '出库' }),
    value: 'O',
  },
  {
    label: $i18n.get({ id: 'InTheDatabase.four_px', dm: '库内' }),
    value: 'M',
  },
];

const INVENTORY_STRATEGY_PIN_LEVEL = [
  {
    label: 'A',
    value: 'A',
  },
  {
    label: 'B',
    value: 'B',
  },
  {
    label: 'C',
    value: 'C',
  },
  {
    label: 'D',
    value: 'D',
  },
];

/**
 * 库存SKU批量查询
 */
const INSIDE_SKU_QUERY = [
  {
    label: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
    value: 'skuCodes',
  },

  {
    label: $i18n.get({ id: 'SKUTM.SkuBarCode.four_px', dm: 'SKU条码' }),
    value: 'skuIdOrProductCodes',
  },
];

const REPLENISH_SERVICES = 'giws-cuvie';

const BASEDATA_SERVICES = 'giws-basic';

const INSIDE_SERVICES = '/inventory/inventory';

export {
  IS_SPLIT,
  DEVAN_TIME_TYPE,
  DIFF_TYPE,
  DEVAN_LIST_TYPE,
  REPLENISH_STATUS,
  REPLENISH_TYPE,
  REPLENISH_SERVICES,
  ENTER_DIFFER,
  REPLENISH_TIME_TYPE,
  ACTION_TYPE,
  ABNOR_TYPE,
  REPLE_CARGO_TYPE,
  REPLE_ABCTYPE,
  INVENTORY_LIST_TAB,
  INVENTORY_FIND_TAB,
  CHECK_MODE,
  IS_SPLICE,
  RANGE_SOURCE,
  CHECK_TYPE,
  CHECK_TYPE_CREATE,
  CHECK_STATUS,
  CHECK_TASK_TYPE,
  INVENTORY_ANBOR_TAB,
  IS_DIFF,
  IS_DIFF_TABLE,
  CHECK_MODE_ALL,
  CHECK_TYPE_ALL,
  INVENTORY_STATUS,
  MOVEKU_ACTION_TYPE,
  INVENTORY_STRATEGY_MODEL,
  INVENTORY_STRATEGY_PIN_LEVEL,
  INSIDE_SKU_QUERY,
  INSIDE_SERVICES,
  BASEDATA_SERVICES,
};
